import { PropsWithChildren } from 'react'
import { RECAPTCHA_SITE_KEY } from '../config'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export const ReCaptchaProvider = ({ children }: PropsWithChildren) => {
  return (
    <GoogleReCaptchaProvider
      container={{ parameters: { expiredCallback: () => console.error('expired') } }}
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      key={RECAPTCHA_SITE_KEY}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}
